/* eslint-disable max-len */
export default {
  ACTIONS: {
    HOME: 'Home',
    LOGOUT: 'Logout',
    NEXT: 'Next',
    SUBMIT: 'Submit',
    USERS: 'Users'
  },
  ERRORS: {
    BASE:
      'Something went wrong … Sorry about that! Please try again in a few minutes. 🥴'
  },
  MESSAGES: {
    NOT_FOUND: 'Page not found',
    ORDER: 'Order',
    OTHER: 'Other',
    OTHER_RET: 'Other...',
    PROZIS_NOW: 'PROZIS NOW',
    UNAUTHORIZED: 'You don\'t have access'
  },
  SENTENCES: {
    NOT_FOUND: 'Sorry, we couldn\'t find what you\'re looking for.',
    UNAUTHORIZED:
      'Sorry, you don\'t have access to this. Should you need access, please contact us.'
  }
};
